/**
 * Formats RIA date range for analytics events only.
 * This utility is not used for UI display or business logic.
 *
 * @param dateRange - Date range object with dateLow and dateHigh in ISO 8601 format
 * @returns Formatted string for riaDateRange property in analytics events
 */
type RiaDateRange = {
  dateLow: string | null
  dateHigh: string | null
}

/**
 * Helper to extract YYYY-MM from ISO date string
 */
function extractYearMonth(isoString: string): string {
  const date = new Date(isoString)
  if (isNaN(date.getTime())) {
    return ''
  }
  const year = date.getUTCFullYear()
  const month = String(date.getUTCMonth() + 1).padStart(2, '0')
  return `${year}-${month}`
}

export function formatRiaDateRange(dateRange: RiaDateRange): string {
  const { dateLow, dateHigh } = dateRange
  const now = new Date()
  const currentYearMonth = `${now.getUTCFullYear()}-${String(now.getUTCMonth() + 1).padStart(2, '0')}`

  if (dateLow !== null && dateHigh !== null) {
    const lowYearMonth = extractYearMonth(dateLow)
    const highYearMonth = extractYearMonth(dateHigh)

    if (lowYearMonth === highYearMonth) {
      return lowYearMonth
    }
    return `${lowYearMonth}_to_${highYearMonth}`
  }

  if (dateLow !== null) {
    const lowYearMonth = extractYearMonth(dateLow)
    if (lowYearMonth === currentYearMonth) {
      return lowYearMonth
    }
    return `${lowYearMonth}_to_${currentYearMonth}`
  }

  if (dateHigh !== null) {
    const highYearMonth = extractYearMonth(dateHigh)
    return `up_to_${highYearMonth}`
  }

  return 'any_time'
}
